
function Down({ size = 16 }) {
	return (
		<svg height={size} width={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
			<g fill="#000000">
				<path
					d="M8,12c-0.232,0-0.463-0.08-0.651-0.241l-7.759-6.65L0.892,3.59L8,9.683l7.108-6.093l1.302,1.519l-7.759,6.65 C8.463,11.92,8.232,12,8,12z"
					fill="#000000"
				/>
			</g>
		</svg>
	);
}

export default Down;
